import placeholder from "@images/placeholder.png";
import { ReactElement, useState } from "react";

import {
  integrations,
  isIntegrationType,
} from "../types/integration_definitions";

type IntegrationIconProps = {
  alt?: string;
  className?: string;
  integrationType?: string;
  src?: string;
};

const IntegrationIcon = ({
  alt = "",
  className = "",
  integrationType,
  src,
}: IntegrationIconProps): ReactElement => {
  const safeType = isIntegrationType(integrationType)
    ? integrationType
    : undefined;

  const defaultTypeImage =
    safeType && integrations[safeType]?.icon
      ? integrations[safeType].icon
      : placeholder;
  const [imgSrc, setImgSrc] = useState(src ?? defaultTypeImage);

  return (
    <img
      alt={alt}
      className={className}
      onError={() => {
        if (imgSrc !== placeholder) {
          setImgSrc(placeholder);
        }
      }}
      src={imgSrc}
    />
  );
};

export default IntegrationIcon;
